import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { observer } from 'mobx-react-lite';

import { actions as feelingActions } from './actions/actions';
import {
  sessionState,
  sessionDispatch,
  allSessionProps,
} from '../../selectors/sessionSelectors';
import { findDoctor } from '../../selectors/appointmentSelectors';
import styles from './reason.module.css';
import FeelingForm from './components/FeelingForm/index';
import CtaButton from '../../components/CtaButton/index';
import Header from '../../components/UIContainer/MobileUI/header/index';
import { go } from '../../routes/index';
import { isDesktop } from '../../config';
import FeelingFormMobile from './components/FeelingFormMobile/index';
import cssVars from 'css-vars-ponyfill';
import { useAppointmentStore, usePracticesStore } from 'store/mobx/mobx';
import { useComponentDidMount } from 'libs/newHttp';
import styled from 'styled-components';

const Scroller = styled.ul``;
const Reason = observer(
  ({
    addFeelings,
    skipFeelings,
    createSession,
    getConsultMethods,
    clearFeelings,
    isFetching,
    viewPatientDetails,
    practice,
    appointment,
    doctor,
    viewGuardianDetails,
    token,
    _note,
    firstName,
    isBookingForSomeoneElse,
    isFormValid,
    sessionDetails,
    reasons,
    postService,
    updateSession,
    preSelectedService,
  }) => {
    const store = useAppointmentStore();
    const practiceStore = usePracticesStore();
    const { id } = useParams();

    const [note, setNote] = useState('');
    const [clinicalReasons, setClinicalReasons] = useState(
      store.getSelectedSymptoms() ?? [{}, {}],
    );

    const [showSearch, setShowSearch] = useState([false, false, false]);
    const [selectMethod, setSelectMethod] = useState(''); // selected consult method
    const [selectedService, setSelectedService] = useState(
      preSelectedService ?? store.getSelectedService() ?? {},
    );
    const [filteredServices, setFilteredServices] = useState(reasons.Services);

    useComponentDidMount(() => {
      cssVars();

      if (!isDesktop()) {
        window.scrollTo(0, 0);
      }
    });

    const onChange = e => {
      setNote(e.target.value);
    };

    const changeService = service => {
      setSelectedService(service);
      store.setSelectedService(service);
    };

    const changeReason = (reason, i) => {
      let reasons = clinicalReasons;
      reasons[i] = reason;

      if (!reasons[0]?.Name && reasons[1]?.Name) {
        reasons.shift();
      }

      setClinicalReasons(reasons);
      store.setSelectedSymptoms(reasons);
    };

    const handleCta = async () => {
      let urgent = false;
      let corona = false;

      let reasonOne = clinicalReasons[0];
      let reasonTwo = clinicalReasons[1];

      if (
        reasonOne?.ByPassCode === undefined &&
        reasonTwo?.ByPassCode === undefined
      ) {
        if (reasons.NoSymptomDefaultByPassCode === 1) {
          urgent = true;
        } else if (reasons.NoSymptomDefaultByPassCode === 2) {
          corona = true;
        }
      } else {
        if (reasonOne?.ByPassCode === 1 || reasonTwo?.ByPassCode === 1)
          urgent = true;
        if (reasonOne?.ByPassCode === 2 || reasonTwo?.ByPassCode === 2)
          corona = true;
      }

      var symptomIds = [];

      if (reasonOne?.Id !== undefined) symptomIds.push(reasonOne.Id);
      if (reasonTwo?.Id !== undefined) symptomIds.push(reasonTwo.Id);

      if (doctor.ShowServiceQuestionnaire) {
        store.setSelectedConsultMethod(selectMethod);
        store.setSelectedService(selectedService);
        store.setPatientNotes(note);
        //load questionnaire before navigating to service info to avoid flickering
        await store.getServiceQuestionnaire(id, selectedService.Id);
        go.serviceinfo(id, selectedService.Id);
        return;
      }

      if (urgent) {
        go.urgentAttention(
          practice.UrlName,
          practice,
          sessionDetails.SessionId,
          selectMethod,
          symptomIds,
          note,
          JSON.stringify(selectedService),
        );
      } else if (corona) {
        go.corona(
          practice.UrlName,
          practice,
          reasons.AllowContinueWithCode2,
          reasons.Code2WarningMessage,
          sessionDetails.SessionId,
          selectMethod,
          symptomIds,
          note,
          JSON.stringify(selectedService),
        );
      } else {
        updateSession(
          sessionDetails.SessionId,
          selectMethod,
          symptomIds,
          note,
          selectedService,
          practice.UrlName,
        );
      }
    };

    const setSearch = (i, value) => {
      let search = [...showSearch];
      search[i] = value;

      setShowSearch(search);
    };

    const stopAllSearch = () => {
      setShowSearch([false, false, false]);
    };

    const enableCta = () => {
      if (selectedService?.MustProvideReason) {
        return !!note;
      }
      return selectedService?.Name;
    };

    function enrolledOnly(service) {
      return !service.EnrolledOnly;
    }

    function offeredServiceOnly(service) {
      if (
        sessionDetails.AvailableServices &&
        sessionDetails.AvailableServices.length > 0
      ) {
        return sessionDetails.AvailableServices.includes(service.Id);
      }
      if (!doctor.Services || doctor.Services.length === 0) {
        return true;
      }
      return doctor.Services.includes(service.Id);
    }

    useEffect(() => {
      if (reasons?.Services && sessionDetails) {
        setFilteredServices(reasons.Services?.filter(offeredServiceOnly));
      }
    }, [reasons.Services]);

    let s1 = showSearch.includes(true) && !showSearch[0] ? true : false;
    let s2 = showSearch.includes(true) && !showSearch[1] ? true : false;
    let s3 = showSearch.includes(true) && !showSearch[2] ? true : false;

    return (
      <div className={styles.feelingPage}>
        {!isDesktop() && !showSearch.includes(true) && (
          <Header
            headerClassNames={styles.header}
            goBackFn={() =>
              practice.MustLoginBeforeBooking
                ? go.practiceBooking(practice.UrlName, true)
                : go.patientSelection(practice.UrlName)
            }
            showHelp
          />
        )}
        <Scroller className={styles.formContainer}>
          {isDesktop() && (
            <div>
              <div className={styles.desktopLabel}>
                What&#39;s your reason for consultation to help us plan your
                visit better?
              </div>
            </div>
          )}
          <div
            className={styles.label}
            style={{ display: showSearch.includes(true) ? 'none' : '' }}
          >
            What&#39;s your reason for consultation to help us plan your visit
            better?
          </div>
          <div className={styles.formInnerContainer}>
            {isDesktop() ? (
              <FeelingForm
                visible={practiceStore.selectedPractice.ModuleVisibility.includes(
                  'Reason For Visit',
                )}
                isFetching={isFetching}
                reasons={reasons}
                Services={filteredServices}
                SelectedService={selectedService}
                Symptoms={reasons.Symptoms}
                SelectedSymptoms={clinicalReasons}
                changeService={changeService}
                changeReason={changeReason}
                isBookingForSomeoneElse={isBookingForSomeoneElse}
                onChange={onChange}
                note={note}
                name={firstName}
                consult={reasons.ConsultationMethodes?.length > 0}
                methods={reasons.ConsultationMethodes}
                setMethod={method => setSelectMethod(method)}
                showWarning={reasons.ShowingWarning}
                warningMessage={reasons.WarningMessage}
                postService={item => setSelectedService(item)}
                sessionDetails={sessionDetails}
                showServiceQuestionnaire={doctor.ShowServiceQuestionnaire}
              />
            ) : (
              <div>
                <FeelingFormMobile
                  s1={s1}
                  s2={s2}
                  s3={s3}
                  anySearchOpen={showSearch.includes(true)}
                  setShowSearch={setSearch}
                  stopAllSearch={stopAllSearch}
                  visible={practiceStore.selectedPractice.ModuleVisibility.includes(
                    'Reason For Visit',
                  )}
                  reasons={reasons}
                  Services={filteredServices}
                  SelectedService={selectedService}
                  Symptoms={reasons.Symptoms}
                  SelectedSymptoms={clinicalReasons}
                  changeService={changeService}
                  changeReason={changeReason}
                  isBookingForSomeoneElse={isBookingForSomeoneElse}
                  onChange={onChange}
                  note={note}
                  name={firstName}
                  methods={reasons.ConsultationMethodes}
                  consult={reasons.ConsultationMethodes?.length > 0}
                  setMethod={method => setSelectMethod(method)}
                  showWarning={reasons.ShowingWarning}
                  warningMessage={reasons.WarningMessage}
                  postService={item => setSelectedService(item)}
                  sessionDetails={sessionDetails}
                  showServiceQuestionnaire={doctor.ShowServiceQuestionnaire}
                />
              </div>
            )}
          </div>
        </Scroller>
        <div
          className={styles.footer}
          style={{ display: showSearch.includes(true) ? 'none' : '' }}
        >
          <div className={styles.bottomNote}>
            Note that practice staff can view this information.
          </div>
          <CtaButton
            className={styles.cta}
            onClick={handleCta}
            active={enableCta()}
          />
        </div>
      </div>
    );
  },
);

// get the patient whom the appointment is booked for
const getPatientDetails = (
  isLoggedIn,
  isBookingForSomeoneElse,
  profile,
  sessionDetails,
) => {
  if (isLoggedIn && !isBookingForSomeoneElse) {
    return profile;
  }
  return {
    DependantId: sessionDetails.dependantId,
    FirstName: sessionDetails.firstName,
    LastName: sessionDetails.lastName,
    Mobile: sessionDetails.mobile,
    DateOfBirth: sessionDetails.dateOfBirth,
    MobileVerified: profile.MobileVerified,
  };
};
const getGuardianDetails = (isBookingForSomeoneElse, token, sessionDetails) => {
  if (isBookingForSomeoneElse && !token) {
    return {
      FirstName: sessionDetails.initiatorFirstName,
      LastName: sessionDetails.initiatorLastName,
      Mobile: sessionDetails.initiatorMobile,
      DateOfBirth: sessionDetails.initiatorDateOfBirth,
    };
  }
  return null;
};
const mapStateToProps = state => {
  const sessionProps = sessionState([])(state);
  const token = state.loginReducer.token;
  const profile = state.profileReducer.profile;
  const viewPatientDetails = getPatientDetails(
    token,
    sessionProps.isBookingForSomeoneElse,
    profile,
    sessionProps,
  );
  const viewGuardianDetails = getGuardianDetails(
    sessionProps.isBookingForSomeoneElse,
    token,
    sessionProps,
  );

  return {
    token,
    ...sessionProps,
    viewPatientDetails,
    viewGuardianDetails,
    reasons: state.feelingPageReducer.reasons,
    methods: state.feelingPageReducer.methods,
    isFetching:
      state.sessionReducer.isFetching || state.feelingPageReducer.isFetching,
    // @TODO: put this in a selector
    doctor: findDoctor(
      state.practiceAppointmentReducer.selectedTime.doctorId,
      state.practiceAppointmentReducer.doctorInfo.doctors.length
        ? state.practiceAppointmentReducer.doctorInfo.doctors
        : state.practiceProfileReducer.profile.Doctors,
    ),
    appointment: moment(state.practiceAppointmentReducer.selectedTime.time),
    practice: isDesktop()
      ? state.practiceProfileReducer.profile
      : state.practiceProfileReducer.profile || {},
    note: state.feelingPageReducer.feelings,
    service: state.service,
    symptoms: state.symptoms,
    SymptomsObj: state.feelingPageReducer.Symptoms,
    received: state.feelingPageReducer.received,
    showWarning: state.feelingPageReducer.showWarning,
    warningMessage: state.feelingPageReducer.warningMessage,
    allowContinueWithCode2: state.feelingPageReducer.allowContinueWithCode2,
    code2WarningMessage: state.feelingPageReducer.code2WarningMessage,
    noSymptomDefaultByPassCode:
      state.feelingPageReducer.noSymptomDefaultByPassCode,
    patientId: state.checkEnrollmentReducer.patientId,
    sessionDetails: state.checkEnrollmentReducer.session,
    preSelectedService: state.practiceAppointmentReducer.selectedService,
  };
};

const mapDispatchToProps = dispatch => ({
  createSession: sessionDispatch(dispatch)(allSessionProps),
  getConsultMethods: bindActionCreators(
    feelingActions.getConsultMethods,
    dispatch,
  ),
  addFeelings: bindActionCreators(feelingActions.addFeelings, dispatch),
  skipFeelings: bindActionCreators(feelingActions.skipFeelings, dispatch),
  clearFeelings: bindActionCreators(feelingActions.clearFeelings, dispatch),
  postService: bindActionCreators(feelingActions.postService, dispatch),
  updateSession: bindActionCreators(feelingActions.updateSession, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reason);
export { styles };
